module.exports = __webpack_public_path__ + "img/select.75c45a39.svg";